import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
    state: {
        username: ''
    },
    mutations: {
        setUsername(state, username) {
            state.username = username;
        }
    },
    actions: {
        updateUsername({ commit }, username) { 
            commit('setUsername', username);
        }        
    },
    getters: {
        username: state => state.username
    },
    plugins: [createPersistedState()]
});

export default store;